import React from "react";
import { navigate } from "hookrouter";
import cogoToast from "cogo-toast";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import EpisodeHeader from "../EpisodeHeader";
import Loading from "../../Loading";
import styles from "./EpisodeCreate.module.css";
import { useEpisode, useEpisodes } from "../EpisodeHooks";

const Create = ({ storyID, episodeID }) => {
  const [title, setTitle] = React.useState("Untitled Episode");
  const [content, setContent] = React.useState("");
  const [setEpisode, loading] = useEpisode(storyID, episodeID);
  const [episodes] = useEpisodes(storyID);
  const titleRef = React.useRef();

  var toolbarOptions = [
    ["bold", "italic", "underline", "strike"],
    [{ header: 1 }, { header: 2 }],
    [{ size: ["small", false, "large", "huge"] }],
    ["link", "image"],

    ["clean"], // remove formatting button
  ];

  React.useEffect(() => {
    if (episodeID && episodes.length !== 0) {
      const currentEpisode = episodes.filter((e) => e._id === episodeID)[0];
      setTitle(currentEpisode.episodeName);
      setContent(currentEpisode.episodeContent);
    }
  }, [episodes, episodeID]);

  const handleSubmit = async (e) => {
    const formData = new FormData();
    formData.append("episodeName", title);
    formData.append("episodeContent", content);
    formData.append("storyId", storyID);
    const type = e.target.name;

    if (e.target.name === "publish") {
      formData.append("status", "Published");
    } else {
      formData.append("status", "Draft");
    }

    const resp = await setEpisode(formData);

    if (resp.success) {
      cogoToast.success(
        "Succesfully " + type === "publish" ? "Published!" : "Saved"
      );
      if (episodeID) {
        navigate(`/myepisode/${storyID}/${episodeID}`);
      } else {
        navigate(`/myepisode/${resp.Episode.Story}/${resp.Episode._id}`);
      }
    }
  };

  React.useEffect(() => {
    titleRef.current.focus();
  }, [titleRef]);

  return (
    <div className={styles.formWrapper}>
      <Loading top={true} loading={loading} />
      <EpisodeHeader
        storyID={storyID}
        episodeTitle={title}
        create={handleSubmit}
        myStory={true}
      />
      <form onSubmit={handleSubmit}>
        <div className={styles.label}> Episode Title</div>
        <input
          ref={titleRef}
          className={styles.field}
          type="text"
          value={title}
          onChange={(e) => setTitle(e.target.value)}
        />
        <div className={styles.label}> Episode Content</div>
        <ReactQuill
          className={styles.editor}
          theme="snow"
          modules={{ toolbar: toolbarOptions }}
          value={content}
          onChange={setContent}
        />
      </form>
      <div className={styles.fadeOverlay} />
    </div>
  );
};

export default Create;
